import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ProjectStore, SessionRepository } from '@frontend-site/shared/core';
import { Observable } from 'rxjs';
import { Destroyable, takeUntilDestroy } from '@frontend-site/shared/utils';
import { map } from 'rxjs/operators';
import { ApplicationConfig, ProjectInfo } from '@frontend-site/shared/data';

@Injectable({
    providedIn: 'root'
})
export class IssuesGuard extends Destroyable  {
    constructor(private readonly store: ProjectStore, private readonly session: SessionRepository) {
        super();
    }

    canActivate(route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): Observable<boolean> {
        return this.store.projectDetails$.pipe(
            takeUntilDestroy(this),
            map(
                (projectDetails) =>
                    (projectDetails && !(projectDetails as ProjectInfo).isIcr3Project()) ||
                    (this.session.applicationConfig as ApplicationConfig).isExecuteUser
            )
        );
    }
}
